//  export const LOCAL_URL = "http://127.0.0.1:8000/api";
// export const LOCAL_URL = "https://uatapps.gtechdistributions.com/api";
// changed global url
export const LOCAL_URL = "https://apps.gtechdistributions.com/api";
